import { render, staticRenderFns } from "./RecyclerMenuList.vue?vue&type=template&id=39276c2d&"
import script from "./RecyclerMenuList.vue?vue&type=script&lang=ts&"
export * from "./RecyclerMenuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports